export default "__VITE_ASSET__1124f311__"